export default class CheckoutApiError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
